import React from 'react';

export const BirdSilhouette = ({ className }) => {
  return (
    <div className={className}>
      <svg viewBox="0 0 40 20" width="30" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          className="bird-wing"
          d="M20 12 C15 4, 8 2, 2 6 C8 4, 14 6, 20 12"
          fill="#2D4A2D"
          style={{ transformOrigin: '20px 12px' }}
        />
        <path
          className="bird-wing"
          d="M20 12 C25 4, 32 2, 38 6 C32 4, 26 6, 20 12"
          fill="#2D4A2D"
          style={{ transformOrigin: '20px 12px' }}
        />
        <circle cx="20" cy="13" r="2" fill="#2D4A2D" />
      </svg>
    </div>
  );
};

export default BirdSilhouette;
